import {
  UPDATE_SHARE_LIST,
  RESET_SHARE_LIST,
  IUpdateShareHotelList,
  IResetShareHotelList
} from './types';

export function updateShareHotelList(data): IUpdateShareHotelList {
  return {
    type: UPDATE_SHARE_LIST,
    actionData: data,
  };
}

export function resetShareHotelList(): IResetShareHotelList {
  return {
    type: RESET_SHARE_LIST,
    actionData: null,
  };
}
